
import { rateHundredCalc2, classUpDownConverter } from '~/utils/'

export default {
    name: 'TodayIssueList',
    props: {
        newsItems: {
            type: Array,
            default() {
                return []
            },
        },
        columns: {
            type: Array,
            default() {
                return []
            },
        },
        setDate:{
            type: String,
            default: null,
        }
    },
    methods: {
        viewNum(value) {
            if(value){
                let rate = rateHundredCalc2(value)
                rate = rate.toFixed(2)
                const sign = rate > 0 ? '+' : ''
                return sign + rate + '%'
            }
        },
        upDownCssApply(value) {
            return classUpDownConverter(value)
        },
        onClickStock(code) {
            const routeData = this.$router.resolve({
                name: `/stockitem?code=${code}`,
            })
            window.open(
                routeData.location.name,
                'StockItem',
                'width=1200px,height=1000,scrollbars=1,resizable=yes'
            )
        },
        // 22.05.17 52주신고가 금액 + ',' 포맷 
        numberFormat(value){ 
            value = value.toString()
            let position = value.length-3
            let output
            // 221107 meej 3자리수 일경우 그대로 출력
            if(value.length > 3){
                output = [value.slice(0, position), ',', value.slice(position)].join('')
            } else {
                output = value
            }
            if(value.length > 6){
                position = value.length-6
                output = [output.slice(0, position), ',', output.slice(position)].join('')
            } 
            if(value.length > 9){
                position = value.length-9
                output = [output.slice(0, position), ',', output.slice(position)].join('')
            }
            // console.log('output', output)
            return output+'원'
        },
        // 급등락사유분석 URL 링크연결
        setUrl(text){
            console.log('original text: ', text)
            // 22.06.28 suye 급등락사유분석 url 링크걸기 
            const limit = /(http(s)?:\/\/|www.)([/a-z0-9-%#?&=\w]+\.*)+[a-z0-9]{2,4}([/a-z0-9-%#?&=;\w])+(\.[a-z0-9]{2,4}(\?[/a-z0-9-%#?&=;\w]+(?![^<]*?<\/br\/>))*)*/gi
            // const limit = /(http(s)?:\/\/|www.)([a-z0-9\w]+\.*)+[a-z0-9]{2,4}([/a-z0-9-%#?&=\w])+(\.[a-z0-9]{2,4}(\?[/a-z0-9-%#?&=;\w]+)*)*/gi
            const test = text.match(limit) // url 정규식 거르기
            // console.log('test', test)
            
            // 정규식으로 걸러야하는 url이 존재할 경우 
            if (test !== null){
                if(!text.includes('<a href="http')){ // 22.08.29 suye 변경된 링크 삽입 방식
                    test.forEach(e => {
                        text = text.replaceAll(e, ('<a target="_blank" style="color: blue; text-decoration: underline;" href="' + e + '">' + e +'</a>'))    
                    });
                    console.log('after: ', text)
                    const removedText = []
                    // <a>태그가 잘못들어가는 경우 
                    // ex. <a target="_blank" href="<a target=" _blank"="">https:</a>
                    if(text.includes('href="<a target="_blank"')){
                        let splitText = [] 
                        splitText = text.split('<br>') // 줄바꿈 기준으로 텍스트 분리 
                        console.log('splitText', splitText)
                        splitText.forEach(e => { 
                            let cut = []
                            let textConcat = ''
                            e = '<br>'+e
                            if(e.includes('href="<a target="_blank" ')){ // 문제의 a태그 소거 
                                // console.log('caught e :', e)
                                e = e.replaceAll('<a target="_blank" href="<a target="_blank" ', '-cut-(deleteText)').replaceAll('</a>">', '-cut-')
                                // console.log('changed e :', e)
                                cut = e.split('-cut-').filter(e => !e.includes('(deleteText)'))
                                // console.log('cut', cut)
                                cut.forEach(text => {
                                    textConcat = textConcat.concat(text) 
                                    e = textConcat
                                    console.log('textConcat ', e)
                                });
                            }
                        removedText.push(e)    
                        });
                        console.log('includes', removedText)
                        let stringTemp = ''
                        removedText.forEach(e => {
                            stringTemp = stringTemp.concat(e)
                        });
                        text = stringTemp
                    } 
                }
            }  
            return text
        },
    },
}
